import { UiPricingComparisonRowModel } from "../../models";

import {
    mockUiPricingComparisonValueModel,
    mockUiPricingComparisonValueModelContent
} from "./mock-ui-pricing-comparison-value";

export function mockUiPricingComparisonRowModel({
    id = "pricing-comparison-row-1234",
    type = "uiPricingComparisonRow",
    locale = "en",
    content = mockUiPricingComparisonRowModelContent()
}: Partial<UiPricingComparisonRowModel> = {}): UiPricingComparisonRowModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiPricingComparisonRowModelContent =
    UiPricingComparisonRowModel["content"];

export function mockUiPricingComparisonRowModelContent({
    entryTitle = "Demo pricing comparison Row",
    title = "Demo pricing comparison Row",
    freeValue = mockUiPricingComparisonValueModel({
        content: mockUiPricingComparisonValueModelContent({})
    }),
    standardValue = mockUiPricingComparisonValueModel({
        content: mockUiPricingComparisonValueModelContent({})
    }),
    premiumValue = mockUiPricingComparisonValueModel({
        content: mockUiPricingComparisonValueModelContent({})
    }),
    enterpriseValue = mockUiPricingComparisonValueModel({
        content: mockUiPricingComparisonValueModelContent({})
    }),
    ...optionals
}: Partial<UiPricingComparisonRowModelContent> = {}): UiPricingComparisonRowModelContent {
    return {
        entryTitle,
        title,
        freeValue,
        standardValue,
        premiumValue,
        enterpriseValue,
        ...optionals
    };
}
